import { Input } from "src/features/calculator/types/formula"

// S-FIT
// 特殊ケース
// 立替金送金額 = 立替元本
export function calcRemittance({ totalReimbursement }: Input): number {
  return totalReimbursement
}
